// @ts-nocheck
;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = undefined;globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesDistDir"] = ".next";import * as Sentry from "@sentry/nextjs";

export async function register() {
  if (
    process.env.SENTRY_DISABLED === "true" ||
    process.env.NODE_ENV === "development"
  ) {
    return;
  }

  if (process.env.NEXT_RUNTIME === "nodejs") {
    await import("./sentry.server.config");
  }

  if (process.env.NEXT_RUNTIME === "edge") {
    await import("./sentry.edge.config");
  }
}

// We need NextJS 15 to use this
export const onRequestError = Sentry.captureRequestError;
